import React from 'react';

import { useClassName } from 'common/hooks';
import { SVGIcon } from 'common/components';

import './message.less';

const TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
};

const ICONS = {
  [TYPES.WARNING]: 'warning',
  [TYPES.SUCCESS]: 'success',
  [TYPES.INFO]: 'info',
};

export const Message = ({ content, type, className, hideIcon, style }) => {
  const classNames = useClassName('Message');

  return (
    <div
      className={`${classNames('container')} ${classNames(type)} ${className}`}
      style={style}>
      {!hideIcon && <SVGIcon name={ICONS[type]} size="small" />}
      <div className={`${classNames('content')}`}>{content}</div>
    </div>
  );
};

export const WarningMessage = ({ content, className, style }) => (
  <Message
    content={content}
    type="warning"
    className={className}
    style={style}
  />
);

export const InfoMessage = ({ content, className, hideIcon, style }) => (
  <Message
    content={content}
    type="info"
    className={className}
    style={style}
    hideIcon={hideIcon}
  />
);
